import React from 'react';

import { cropperImage } from '../../canvas/common/crop-image';
import { fabric } from 'fabric';

import ImageFace4 from '../../images/face_4.png';
import ImageFace5 from '../../images/face_5.png';

export class AvatarDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCropAvailable: false,
    };
    this.isLoadingFile = false;
  }

  async componentDidUpdate() {
    if (this.props.file && this.props.isValidRange && !this.isLoadingFile) {
      const fabricCanvas = new fabric.Canvas('avatar-canvas', {
        preserveObjectStacking: 'true',
      });
      this.isLoadingFile = true;
      await cropperImage.readFileImage(fabricCanvas, this.props.file, true);
      this.setState({ isCropAvailable: true });
      this.isLoadingFile = false;
    }
  }

  render() {
    return (
      <div id='modal-dialog-avatar' className='AvatarDialog'>
        <div className='dialog--modal'>
          <div className='dialog-sm__header text-center'>顔写真の切り抜き</div>
          <div className='dialog-sm__body'>
            <div className='description-left'>
              <p className='description-text__top'>サイズ調整方法</p>
              <img className='description-image' alt='' src={ImageFace4} />
            </div>
            <div className='cropper'>
              <div className='cropper-preview'>
                <canvas id='avatar-canvas' />
              </div>
            </div>
            <div className='description-right'>
              <img className='description-image' alt='' src={ImageFace5} />
              <p className='description-text__bottom'>適切な写真</p>
            </div>
          </div>
          <div className='dialog-sm__footer'>
            <button className='btn-fixedsize--sub' onClick={this.props.close}>
              キャンセル
            </button>
            <button
              disabled={!this.state.isCropAvailable}
              className={
                this.state.isCropAvailable
                  ? 'btn-fixedsize'
                  : 'btn-fixedsize btn--disabled'
              }
              onClick={e => {
                e.preventDefault();
                if (this.state.isCropAvailable) {
                  this.props.submit(cropperImage.getCroppedDataUrl());
                }
              }}
            >
              決定
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/AvatarDialog.jsx